


import { Component, Vue } from 'vue-property-decorator';
import CompleteStep from '@/utils/mixins/completeStep';
import ConfContainer from '../../components/ConfContainer/index.vue';
import PageTransitionMode from '@/utils/mixins/pageTransitionMode';
import { namespace } from 'vuex-class';
import { Floor } from '../../utils/api';
import { SelectType } from '../../components/SelectionPanel/SelectionPanel.models';
import { RenderMode, HouseView } from '../../components/ConfContainer/ConfContainer.models';
import { Layer } from '../../components/LayeringEngine/LayeringEngine.models';

const configurationModule = namespace('configuration');
const roofShapeModule = namespace('roofShape');

@Component({
  mixins: [CompleteStep, PageTransitionMode],
  components: { ConfContainer }
})
export default class RoofShape extends Vue {
  @configurationModule.State private houseConfiguration!: Layer[];
  @configurationModule.State private fromNull!: boolean;
  @roofShapeModule.Getter private floor!: Floor;

  // to make ts enums work in vue template
  private SelectType: typeof SelectType = SelectType;
  private RenderMode: typeof RenderMode = RenderMode;
  private HouseView: typeof HouseView = HouseView;
}
